module.exports = __webpack_public_path__ + "img/logout.e10f594d.svg";